<div class="d-flex flex-column align-items-center">
    <div class="card mt-5 col-md-6 p-4 mr-0 p-gutter flex-auto max-w-[700px]">
      <div class="d-flex flex-column align-items-end" (click)="close()"> <span style="cursor: pointer;">&times;</span></div>
      <h5>{{paused ? 'Are you sure you want to un-pause?':'Are you sure you want to pause?'}}</h5>
      <div class="form-group">
        <input id="pause" type="checkbox" class="form-check-input"  (change)="onChange($event)"/>
        <label for="pause" class="form-check-label ml-2">{{ paused ? ' Allow proctor to pause?':'Allow proctor to un-pause?'}}</label>
      </div>      
      <div class="d-flex justify-content-between mt-4">
        <input class="btn btn-primary" type="button" value="YES" (click)="yesClicked()"/>
        <input class="btn btn-danger" type="button" value="CANCEL" (click)="noClicked()"/>
      </div>      
    </div>
</div>